import { nextTick, ref, watch, type Ref } from 'vue';

// A counter, not a flag: a second click after the first request was handled must fire
// again, and a layout mounted later must not replay a request meant for the previous one.
const guideNavigationRequestId: Ref<number> = ref(0);

type GuideTarget = { scrollToGuide: () => void };

/**
 * Ask whichever layout owns the generated summary to show it (SmartActionsList's View Guide,
 * FloatingBarAI's "below" link).
 */
export const useGuideNavigationTrigger = () => {
  const requestGuide = () => {
    guideNavigationRequestId.value += 1;
  };

  return { requestGuide };
};

/**
 * For the component that renders SummaryContent: select the tab that holds it, then
 * scroll and focus it once that tab is in the DOM.
 */
export const useGuideNavigationListener = (summaryContentRef: Ref<GuideTarget | null>, showGuideTab: () => void) => {
  watch(guideNavigationRequestId, async () => {
    showGuideTab();
    await nextTick();
    summaryContentRef.value?.scrollToGuide();
  });
};
